module.exports = __webpack_public_path__ + "media/images/share-twitter-13864782f1df0acd41b7df2bcf1877bd.svg";